import React from "react";

import { GatsbyBrowser } from "gatsby";

import "./src/locales";

import ContextBrowser from "./src/components/Context/Browser";
import RootLayout from "./src/components/RootLayout";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
    element,
    props,
}) => <RootLayout {...props}>{element}</RootLayout>;

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
    element,
}) => {
    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <ContextBrowser>{element}</ContextBrowser>
        </QueryClientProvider>
    );
};
